// extracted by mini-css-extract-plugin
module.exports = {"app":"winampp.style_app__1Z_Uc","player":"winampp.style_player__3qsV0","dragArea":"winampp.style_dragArea__KtDcs","playList":"winampp.style_playList__3C47c"};